import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 }
};

const BLOG_DATA = [
  {
    id: "ciencia-catnip",
    titleKey: "blog_1_title",
    descKey: "blog_1_desc",
    images: [
      "https://images.pexels.com/photos/1170986/pexels-photo-1170986.jpeg",
      "https://images.pexels.com/photos/416160/pexels-photo-416160.jpeg",
      "https://images.pexels.com/photos/104827/cat-pet-animal-domestic-104827.jpeg"
    ],
    url: "https://www.bienestarfelino.com/blog/"
  },
  {
    id: "formas-creativas",
    titleKey: "blog_2_title",
    descKey: "blog_2_desc",
    images: [
      "https://images.pexels.com/photos/2558605/pexels-photo-2558605.jpeg",
      "https://images.pexels.com/photos/1543793/pexels-photo-1543793.jpeg",
      "https://images.pexels.com/photos/569170/pexels-photo-569170.jpeg"
    ],
    url: "https://www.feelcats.com/"
  },
  {
    id: "cultivo-artesanal",
    titleKey: "blog_3_title",
    descKey: "blog_3_desc",
    images: [
      "https://images.pexels.com/photos/1741205/pexels-photo-1741205.jpeg",
      "https://images.pexels.com/photos/1276553/pexels-photo-1276553.jpeg",
      "https://images.pexels.com/photos/617278/pexels-photo-617278.jpeg"
    ],
    url: "https://lacasitadelosanimales.com/blog/gatos/"
  },
  {
    id: "cats-com",
    titleKey: "blog_4_title",
    descKey: "blog_4_desc",
    images: [
      "https://images.unsplash.com/photo-1727891376277-563bec1bc696",
      "https://images.pexels.com/photos/45201/kitty-cat-kitten-pet-45201.jpeg",
      "https://images.pexels.com/photos/320014/pexels-photo-320014.jpeg"
    ],
    url: "https://es.cats.com/"
  }
];

export const BlogSection = ({ t }) => (
  <section className="py-12 md:py-24 px-4 md:px-8 bg-agave/5">
    <div className="max-w-7xl mx-auto">
      <motion.div {...fadeUp} className="text-center mb-8 md:mb-12">
        <h2 className="font-gluten text-2xl sm:text-3xl md:text-4xl text-agave mb-4">
          {t("blog_title")}
        </h2>
        <p className="font-nunito text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto">
          {t("blog_subtitle")}
        </p>
      </motion.div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
        {BLOG_DATA.map((blog, blogIdx) => {
          const hoursPerRotation = 48;
          const currentHour = Math.floor(Date.now() / (1000 * 60 * 60));
          const imageIndex = Math.floor(currentHour / hoursPerRotation + blogIdx) % blog.images.length;
          const currentImage = blog.images[imageIndex];
          return (
            <motion.div
              key={blog.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <a href={blog.url} target="_blank" rel="noopener noreferrer" className="block">
                <Card className="bg-white rounded-2xl md:rounded-3xl overflow-hidden shadow-lg card-lift cursor-pointer" data-testid={`blog-card-${blog.id}`}>
                  <img 
                    src={`${currentImage}?auto=compress&cs=tinysrgb&w=600`}
                    alt={t(blog.titleKey)}
                    className="w-full h-40 sm:h-48 object-cover"
                  />
                  <CardContent className="p-4 md:p-6">
                    <h3 className="font-fredoka font-bold text-lg text-foreground mb-2">
                      {t(blog.titleKey)}
                    </h3>
                    <p className="font-nunito text-muted-foreground text-sm mb-3">
                      {t(blog.descKey)}
                    </p>
                    <span className="font-fredoka text-sm text-agave hover:text-mexican transition-colors">
                      {t("blog_visitar")}
                    </span>
                  </CardContent>
                </Card>
              </a>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
